import React from "react";
import moment from "moment";
import UserIcon from "../../images/v2/Profiles.svg";
import Dropdown from "react-bootstrap/Dropdown";
import ModalMoreIcn from "../../images/modal-more-btn.svg";

function SideBarChatService(props) {
  const { msgData, userId, onSelect } = props;
  console.log({ msgData });
  const calculateTimeAgo = () => {
    return moment(new Date(msgData?.lastMessageAt).toUTCString()).fromNow(true) +" ago";
  }; 

  return (
    <div
      className="msg-left-wrap position-relative  mb-0 bdrbtm  bg-white"
      onClick={() => onSelect(msgData?.userId)}
      role="button"
    >
      <div className="msg-prof-wrap flex-shrink-0">
        <img src={msgData?.profileUrl || UserIcon} alt="User" />
      </div>

      <div className="msg-details flex-grow-1">
        <div className="msg-main-heading">
          {" "}
          {msgData?.firstName} {msgData?.lastName}
        </div>
        <div className="msg-main-text">
          {msgData?.lastMessage} <span> &bull; </span> {calculateTimeAgo()}
        </div>
      </div>

      {/* <div className="message-dpdown-wrap">
        <Dropdown>
          <Dropdown.Toggle variant="" id="dropdown-basic">
            <img src={ModalMoreIcn} alt="More" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item href={void 0}>Delete Chat</Dropdown.Item>
            <Dropdown.Item href={void 0}>Report User</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div> */}
    </div>
  );
}

export default SideBarChatService;
